import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CheckboxSelectField from 'FRONTEND/components/CheckboxSelectField/CheckboxSelectField';
import {
  selectAppoinmentAndAvailabilityLocations,
  updateCheckedLocationsList,
} from 'FRONTEND/reducers/locationSlice';
import { RootState } from 'FRONTEND/reducers/types';
import i18n from 'FRONTEND/utils/i18n';


type LocationFilterFieldProps = {
  isLoading: boolean;
};

const LocationFilterField = ({ isLoading }: LocationFilterFieldProps) => {
  const dispatch = useDispatch();
  const appointmentAndAvailabilityLocations = useSelector(selectAppoinmentAndAvailabilityLocations);
  const allLocationIds = useMemo(() => appointmentAndAvailabilityLocations.map(location => location.id), [appointmentAndAvailabilityLocations]);
  const checkedLocationsList = useSelector((state: RootState) => state.location.checkedLocationsList);

  useEffect(() => {
    if (appointmentAndAvailabilityLocations.length > 0 && checkedLocationsList.length === 0) {
      dispatch(updateCheckedLocationsList({ checkedLocationsList: allLocationIds }));
    }
  }, [appointmentAndAvailabilityLocations]);

  const handleChange = (newCheckedLocationsList: string[]) => {
    dispatch(updateCheckedLocationsList({ checkedLocationsList: newCheckedLocationsList }));
  };

  // Filter checkedLocationsList to only include locations available for current actor
  const validCheckedLocations = useMemo(() => checkedLocationsList.filter(locationId => allLocationIds.includes(locationId)), [checkedLocationsList, allLocationIds]);

  if (appointmentAndAvailabilityLocations.length === 0) {
    return null;
  }

  const locationOptions = appointmentAndAvailabilityLocations.map(location => ({
    value: location.id,
    label: location.display,
  }));

  return (
    <CheckboxSelectField
      options={locationOptions}
      selectedValues={validCheckedLocations}
      onChange={handleChange}
      placeholder={i18n._('Filter by location')}
      selectedPlaceholder={i18n._('Filter by location')}
      isLoading={isLoading}
      fullWidth
    />
  );
};

export default LocationFilterField;
